<template>
  <div v-if="wrapshow">
    <van-popup
      class="quick-picker-range-popup"
      v-model="open"
      position="bottom"
      :style="{ height: '55%' }"
      @closed="wrapshow = false"
    >
      <div class="title">
        选择时间区间
        <van-icon name="cross" @click="close" color="var(--g5)" size="18" />
      </div>

      <div
        class="chooseDate"
        @click="rangeCalendarShow = true"
        :class="{ 'has-date': startDate && endDate }"
      >
        <span v-if="startDate && endDate">
          {{ startDate | formatDatetime('yyyy-MM-dd') }}~{{
            endDate | formatDatetime('yyyy-MM-dd')
          }}
        </span>
        <span v-else> 自定义时间区间 </span>
      </div>

      <div class="choose-nav">
        <div class="fastwrap" v-for="(item, idx) of fastList" :key="idx">
          <div
            class="fastitem"
            :class="{ 'has-date': item === chooseItem }"
            @click="quickChoose(item)"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </van-popup>
    <van-calendar
      v-model="rangeCalendarShow"
      :default-date="defaultDateRange"
      v-bind="attrs"
      type="range"
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
import fast from './fast.js';

export default {
  data() {
    return {
      wrapshow: true,
      open: false,

      startDate: '',
      endDate: '',
      config: {
        // 展示过去还是未来的快捷选择, 1： 过去  2：未来
        type: 1,
        extra: false,
        // pastType: 0 // 展示过去的快捷选择：0 全部，1 近30天
      },

      attrs: {
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2030, 11, 31),
        allowSameDay: true,
        maxRange: 366,
      },

      chooseItem: null,
      rangeCalendarShow: false,

      fastList: [],
    };
  },
  computed: {
    defaultDateRange() {
      if (this.startDate && this.endDate) {
        return [app.tool.date.getDateTime(this.startDate), app.tool.date.getDateTime(this.endDate)]
      } else {
        let now = new Date()
        return [now, now]
      }
    }
  },
  created() {},
  methods: {
    showPicker(opts = {}) {
      return new Promise(resolve => {
        if (opts.startDate) {
          this.startDate = opts.startDate;
        }
        if (opts.endDate) {
          this.endDate = opts.endDate;
        }
        if (opts.config) {
          Object.assign(this.config, opts.config);
        }

        if (opts.attrs) {
          Object.assign(this.attrs, opts.attrs);
        }

        this._resolve = resolve;

        if (this.config.type == 1) {
          this.fastList = fast.past;
        } else {
          this.fastList = this.config.extra ? fast.extraFuture: fast.future;
        }

        this.wrapshow = true;
        this.open = true;
      });
    },
    close() {
      this.open = false;
    },
    confirm() {
      let { startDate, endDate } = this;
      if (!this.startDate && this.endDate) {
        van.Toast('请选择日期范围');
        return false;
      }
      this.close();
      this._resolve({
        startDate,
        endDate,
      });
    },
    quickChoose(item) {
      this.chooseItem = item;
      this.startDate = item.start();
      this.endDate = item.end();
      this.confirm();
    },
    onConfirm(v) {
      this.rangeCalendarShow = false;
      this.startDate = v[0];
      this.endDate = v[1];
      this.confirm();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.quick-picker-range-popup {
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
  .title {
    padding: 0 calc(var(--gap) * 16);
    display: flex;
    height: calc(var(--w) * 48);
    align-items: center;
    justify-content: space-between;
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    color: var(--g8);
  }
  .chooseDate {
    margin: 0 calc(var(--gap) * 16);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--g5);
    height: calc(var(--w) * 40);
    border-radius: var(--radius-lg);
    background-color: var(--g2);
    &.has-date {
      color: var(--c1);
      background-color: rgba(var(--c1-rgb), 0.25);
    }
  }
  .choose-nav {
    padding-top: 16px;
    padding-left: 4px;
    padding-right: 4px;
    display: flex;
    flex-wrap: wrap;
    // margin: calc(var(--gap) * 16) 0 0;
    // padding: 0 calc(var(--gap) * 16);
    .fastwrap {
      padding: 8px 0;
      width: 25%;
      .fastitem {
        margin-left: 4px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        color: var(--g8);
        border-radius: var(--radius-lg);
        background-color: var(--g2);
        &.has-date {
          color: var(--c1);
          background-color: rgba(var(--c1-rgb), 0.25);
        }
      }
    }
  }

  .footer {
    position: absolute;
    padding: calc(var(--gap) * 3) calc(var(--gap) * 16);
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    > button {
      flex: 1;
      &:first-child {
        margin-right: calc(var(--gap) * 16);
      }
    }
  }
}
</style>
